import {string} from 'yup';
import {isIP} from 'is-ip';
import isCidr from 'is-cidr';
import isValidHostname from 'is-valid-hostname';

export const ipString = () =>
   string().test(
      'is-ip',
      'Is not a valid IP address',
      (val) => !val || Boolean(val && (isIP(val) || isCidr(val)))
   );

export const ipOrHosString = () =>
   string().test(
      'is-ip-host',
      'Is not a valid IP address or hostname',
      (val) => !val || Boolean(val && (isIP(val) || isCidr(val) || isValidHostname(val)))
   );
